import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { oneOf, func, string, bool, array } from 'prop-types';

import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import { Segment, Button } from 'semantic-ui-react';


import Form from '~/views/common/Form';
import Heading from '~/views/common/Heading';
import Section from '~/views/common/Section';
import AffiliateSelector from '~/views/common/AffiliateSelector';
import AuthorSelector from '~/views/common/AuthorSelector';
import LicensesForm from '~/views/common/LicenseSytemPortalForm';
import AddressForm from '~/views/common/AddressForm';
import ContactForm from '~/views/common/ContactForm';

import General from './General';
import Settings from './Settings';


const PortalForm = ({
    header,
    submit,
    linkToView = '/col/portalSystem',
    isPortal = false,
    organizatioTypesByItem,
    ...rest
}) => (
    <Fragment>
        <Helmet title={`${header} System Portal`} />
        <Heading
            header="System Portal"
            subheader={header}
            iconName="edit"
        >
            <Button
                type="submit"
                onClick={submit}
                color="green"
                icon="save"
                content="Save"
                labelPosition="right"
            />

            <Button
                as={Link}
                to={linkToView}
                icon="cancel"
            />
        </Heading>

        <Form {...rest}>
            <Segment.Group>
                <General organizatioTypesByItem={organizatioTypesByItem} />

                <Section name="Author">
                    <Field name="author_id" component={AuthorSelector} />
                </Section>
                <Section name="Portal Affiliates">
                    <AffiliateSelector
                        onSubmit={(selectedAffiliates) => { rest.change('portal_affiliates', selectedAffiliates.map(aff => ({ id: aff.id }))); }}
                    />
                </Section>

                <Settings isCreate={false} />

                { isPortal && <LicensesForm /> }

                <ContactForm />

                <AddressForm />

            </Segment.Group>
        </Form>
    </Fragment>
);

PortalForm.propTypes = {
    header: oneOf(['Edit', 'Create']).isRequired,
    submit: func.isRequired,
    linkToView: string,
    isPortal: bool,
    organizatioTypesByItem: array.isRequired,
};

export default PortalForm;
